import { render } from "./IdentityTips.vue?vue&type=template&id=3db4491c"
import script from "./IdentityTips.vue?vue&type=script&lang=js"
export * from "./IdentityTips.vue?vue&type=script&lang=js"

import "./IdentityTips.vue?vue&type=style&index=0&id=3db4491c&lang=scss"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__